import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { MembersDefaultMessage } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/default-message/members-default-message";
import ArrowIcon from "@/components/icons/arrow-icon";
import ProfilePicture from "@/components/user/profile-picture";
import { AbsentMember, EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventReadAbsentMembersProps {
  event: EventRead;
  title: string;
  type: "honoredMembers" | "requests" | "absentMembers" | "attendedMembers";
  defaultMessage: string;
  hasPresidentRole: boolean;
}
export const EventReadAbsentMembers: React.FC<EventReadAbsentMembersProps> = t0 => {
  const $ = _c(8);
  const {
    event,
    title,
    type,
    defaultMessage,
    hasPresidentRole
  } = t0;
  const [showAbsent, setShowAbsent] = useState(true);
  const members = event[type as keyof EventRead] as Array<AbsentMember>;
  let t1;
  if ($[0] !== defaultMessage || $[1] !== hasPresidentRole || $[2] !== members || $[3] !== showAbsent || $[4] !== title) {
    t1 = hasPresidentRole && <div className="flex-1"><div className="mt-6" /><div className="flex justify-between items-center"><p className="font-bold uppercase">{`${title} (${members.length})`}</p><button onClick={() => setShowAbsent(!showAbsent)} className="p-2 hover:bg-gray-100 rounded-full transition-colors"><ArrowIcon size={20} className={`transition-transform duration-200 ${!showAbsent ? "rotate-180" : ""}`} /></button></div>{showAbsent && <>{members.length > 0 ? <div className="flex flex-col mt-4 gap-2">{members.map(_temp)}</div> : <MembersDefaultMessage defaultMessage={defaultMessage} />}</>}</div>;
    $[0] = defaultMessage;
    $[1] = hasPresidentRole;
    $[2] = members;
    $[3] = showAbsent;
    $[4] = title;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <>{t1}</>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
function _temp(t0, index) {
  const {
    firstName,
    lastName,
    avatar
  } = t0;
  return <div className="flex items-center gap-2" key={index}><ProfilePicture size={32} mobileSize={45} className="md:!text-[14px] text-base" firstName={firstName} lastName={lastName} src={avatar?.urls?.avatar_md} alt={`${firstName[0]}. ${lastName}`} /><p className="font-bold h-fit">{firstName} {lastName}</p></div>;
}